module.exports = __webpack_public_path__ + "assets/media/level1-user-icon.06849763.png";